import { clearData } from "./clearData";
import { TaxNameDexie } from "../interfaces/taxNameDexie";

export async function addTaxNames(taxNames: TaxNameDexie[], thisTaxNames): Promise<void> {
    await clearData(thisTaxNames)
    await thisTaxNames.bulkPut(taxNames);
}
